export enum EpisodeValidationAction {
  BookCover = 'book_cover',
  StoryCover ='story_cover',
  Locations = 'locations',
  Branches = 'branches',
  StoryMustHaveLiveAchievement = 'story_must_have_live_achievement',
}
